import { render, staticRenderFns } from "./EnrollLastVerify.vue?vue&type=template&id=a056fbfa"
import script from "./EnrollLastVerify.vue?vue&type=script&lang=js"
export * from "./EnrollLastVerify.vue?vue&type=script&lang=js"
import style0 from "./EnrollLastVerify.vue?vue&type=style&index=0&id=a056fbfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports